import { useEffect, useRef } from 'react';
import { Provider, useMobileContext } from './Provider';

const Mobile = (props) => {
    return <Provider {...props}>
        {props.children}
    </Provider>
};

const useKeyboardHelper = (identifier) => {
    const mobile = useMobileContext();

    useEffect(() => {
        return () => {
            if (mobile && identifier) {
                mobile.showNav(identifier);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!mobile) {
        return {
            hideNav: () => {},
            showNav: () => {},
        };
    }

    return {
        hideNav: () => identifier && mobile.hideNav(identifier),
        showNav: () => identifier && mobile.showNav(identifier),
    };
}

const useStatusBarColour = (colour) => {
    const {setStatusBarColour} = useMobileContext();
    const identifierRef = useRef(`status-bar-${Math.random().toString(36).substr(2, 9)}`);

    useEffect(() => {
        const identifier = identifierRef.current;
        setStatusBarColour(identifier, colour);

        return () => setStatusBarColour(identifier, null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [colour]);
}

export default Mobile;

export {
    useMobileContext as useMobile,
    useKeyboardHelper,
    useStatusBarColour,
}
